export default __webpack_public_path__ + "static/media/Install2.6117ae30.png";